import magikApi from 'magik-api'

const api = magikApi().baseUrl('https://archivio.in-common.org')

export default api
